/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-autofocus */
import React, {useState, useEffect, useRef} from "react";
import {useNavigate} from "react-router";
import {toast} from "react-toastify";
import {Card, FormGroup, Input, InputGroup, InputGroupText} from "reactstrap";
import OtpInput from "react-otp-input";
import logo from "../../assets/img/brand/brand-stacked.svg";
import ZeusButton from "../../components/Button";
import Service from "../../redux/AsyncActions/login.async";
import "./styles.scss";

const ACTIONS = {
  1: "Next",
  2: "Validate OTP",
  3: "Sign In",
};

const Login = ({setShowForgotPassword}) => {
  const navigate = useNavigate();
  const intervalRef = useRef();
  const defaultObject = {email: ""};
  const [auth_object, handleAuthObject] = useState(defaultObject);
  const [action, setAction] = useState(1);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const usernameService = () => {
    setTimer(0);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const callback = (data) => {
      setAction(2);
      intervalRef.current = setInterval(() => setTimer((prevTime) => prevTime + 1), 1000);
      toast.success(data.message);
    };

    if (auth_object.email) {
      Service.validateUserName({email: auth_object.email})
        .then(callback)
        .catch((e) => e);
    } else {
      toast.error("Invalid email");
    }
  };

  const otpService = () => {
    if (auth_object.token) {
      Service.validateOTP({email: auth_object.email, token: auth_object.token})
        .then(() => {
          setAction(3);
        })
        .catch((e) => e);
    } else {
      toast.error("Invalid OTP");
    }
  };

  const loginService = () => {
    if (auth_object.password) {
      Service.login(auth_object)
        .then(() => {
          navigate("/app/home");
        })
        .catch((e) => e);
    } else {
      toast.error("Invalid Password");
    }
  };

  const handleClick = () => {
    const EVENTS = {
      1: usernameService,
      2: otpService,
      3: loginService,
    };

    EVENTS[action]();
  };

  const handleKeyPress = (event) => {
    if (event.keyCode === 13) {
      handleClick();
    }
  };

  useEffect(() => {
    if (auth_object?.token?.length === 6 && action === 2) {
      handleClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth_object]);

  return (
    <div className="containers">
      <div className="bg_img">
        <Card className="login_container">
          <div className={`login_block ${action === 2 ? "login-block-otp" : ""}`}>
            <h3 className="login-header" style={{lineHeight: "26px", fontSize: "22px"}}>
              Login
            </h3>
            <div className="login_area">
              <div className="mb-1">
                {action === 1 && (
                  <small style={{visibility: "hidden"}}>Login with your email.</small>
                )}
                {action === 2 && <small>Please enter your OTP.</small>}
                {action === 3 && <small>Please enter your password.</small>}
              </div>

              {action === 1 && (
                <FormGroup className=" login_field mb-3 mr-4">
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                    <Input
                      placeholder="Email"
                      type="email"
                      autoComplete="new-email"
                      onKeyDown={handleKeyPress}
                      autoFocus={true}
                      id={"email"}
                      // value={auth_object.email}
                      onChange={(e) =>
                        handleAuthObject({
                          ...auth_object,
                          email: e.target.value,
                        })
                      }
                    />
                  </InputGroup>
                </FormGroup>
              )}

              {action === 2 && (
                <FormGroup className="mb-3 mr-4 otp-container">
                  <OtpInput
                    containerStyle={"otp"}
                    inputStyle={"otpInput"}
                    inputType="tel"
                    numInputs={6}
                    onChange={(e) =>
                      handleAuthObject({
                        ...auth_object,
                        token: e,
                      })
                    }
                    renderInput={(props) => <input data-cy={"cy-otp"} {...props} />}
                    shouldAutoFocus
                    value={auth_object.token}
                  />
                </FormGroup>
              )}
              {action === 3 && (
                <FormGroup className="mb-3 mr-4">
                  <InputGroup className="input-group-alternative">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                    <Input
                      onKeyDown={handleKeyPress}
                      autoFocus={true}
                      placeholder="Master Password"
                      type="password"
                      id={"master-password"}
                      autoComplete="new-password"
                      onChange={(e) =>
                        handleAuthObject({
                          ...auth_object,
                          password: e.target.value,
                        })
                      }
                    />
                  </InputGroup>
                </FormGroup>
              )}
              {action === 3 && (
                <div
                  className="mr-4"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <div
                    className="custom-control custom-control-alternative custom-checkbox"
                    style={{paddingBottom: "15px"}}
                  >
                    <input
                      className="custom-control-input"
                      id=" customCheckLogin"
                      data-cy={"remember-me-check"}
                      type="checkbox"
                      onChange={(e) =>
                        handleAuthObject({
                          ...auth_object,
                          rememberMe: e.target.value === "on",
                        })
                      }
                    />
                    <label className="custom-control-label" htmlFor=" customCheckLogin">
                      <span className="text-muted">Remember me</span>
                    </label>
                  </div>
                  <span
                    className="text-muted"
                    style={{fontSize: "14px", cursor: "pointer"}}
                    onClick={() => setShowForgotPassword(true)}
                  >
                    Forgot password ?
                  </span>
                </div>
              )}
              <div className="d-flex">
                <ZeusButton data-cy="submit-btn" onClick={handleClick}>
                  {ACTIONS[action]}
                </ZeusButton>
                {action === 2 && (
                  <ZeusButton
                    type="info-small"
                    onClick={usernameService}
                    disabled={timer <= 20}
                    data-cy="resend-btn"
                  >
                    {`Resend OTP ${timer <= 20 ? 20 - timer : ""}`}
                  </ZeusButton>
                )}
              </div>
            </div>
          </div>
          {/* LOGO BLOCK */}
          <div className="logo_block">
            <img
              className="form-img"
              src={logo}
              alt="ERP logo"
              style={{height: "100%", width: "100%"}}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;
